// ReusableModal.jsx
import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
} from "@chakra-ui/react";
import { Outline } from "react-pdf";

const ReusableModal = ({ isOpen, onClose, title, children, footerButtons }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        {title && <ModalHeader>{title}</ModalHeader>}
        <ModalBody>{children}</ModalBody>
        {footerButtons && (
          <ModalFooter>
            {footerButtons.map((btn, index) => (
              <Button
                color="var(--text-primary)"
                _focusVisible={{ boxShadow: "0" }}
                key={index}
                {...btn.props}
                onClick={() => {
                  if (btn.onClick) btn.onClick();
                  if (btn.closeOnClick) onClose();
                }}
              >
                {btn.label}
              </Button>
            ))}
          </ModalFooter>
        )}
      </ModalContent>
    </Modal>
  );
};

export default ReusableModal;
